import { instanceBo } from "../utils/axios.create";
import {
	ActivitySidebarData,
	CallsData,
	DelayedMissedData,
	InputSubmittedData,
} from "../domain/activitySidebar.interface";

// SIMS-4146: GET /accounts/:accountId/activity-sidebar?coordinatorId=
// (backoffice API — uses instanceBo, whose baseURL already includes the account).
const getActivitySidebar = async (
	coordinatorId: string,
): Promise<ActivitySidebarData> => {
	return instanceBo
		.get("/activity-sidebar", { params: { coordinatorId } })
		.then((res) => res.data.body)
		.catch((err) => Promise.reject(err.response?.data ?? err));
};

// SIMS-4162: Today's Activities call list.
const getCalls = async (
	coordinatorId: string,
	includeDismissed: boolean,
): Promise<CallsData> => {
	return instanceBo
		.get("/activity-sidebar/calls", {
			params: { coordinatorId, includeDismissed },
		})
		.then((res) => res.data.body)
		.catch((err) => Promise.reject(err.response?.data ?? err));
};

// SIMS-4178: Delayed & Missed activity list.
const getDelayedMissed = async (
	coordinatorId: string,
): Promise<DelayedMissedData> => {
	return instanceBo
		.get("/activity-sidebar/delayed-missed", { params: { coordinatorId } })
		.then((res) => res.data.body)
		.catch((err) => Promise.reject(err.response?.data ?? err));
};

// SIMS-4338: Input Submitted feed.
const getInputSubmitted = async (
	coordinatorId: string,
): Promise<InputSubmittedData> => {
	return instanceBo
		.get("/activity-sidebar/input-submitted", { params: { coordinatorId } })
		.then((res) => res.data.body)
		.catch((err) => Promise.reject(err.response?.data ?? err));
};

const dismissCall = async (
	coordinatorId: string,
	callId: string,
): Promise<void> => {
	return instanceBo
		.put(`/activity-sidebar/calls/${callId}/dismiss`, null, {
			params: { coordinatorId },
		})
		.then(() => undefined)
		.catch((err) => Promise.reject(err.response?.data ?? err));
};

const undismissCall = async (
	coordinatorId: string,
	callId: string,
): Promise<void> => {
	return instanceBo
		.delete(`/activity-sidebar/calls/${callId}/dismiss`, {
			params: { coordinatorId },
		})
		.then(() => undefined)
		.catch((err) => Promise.reject(err.response?.data ?? err));
};

export const activitySidebarService = {
	getActivitySidebar,
	getCalls,
	getDelayedMissed,
	getInputSubmitted,
	dismissCall,
	undismissCall,
};
